<div id="gridContainerID_RFH" class="gridContainer">

    <div class="gridContainer">

        @if (!isAenderungsantrag) {
            <h1>
                Neue Bürgschaft beantragen
            </h1>
        } @else {
            <h1 class="goBack" (click)="goBack()">
                Bürgschafts-Änderung beantragen
            </h1>
        }

        @if (vertragHandles && vertragHandles.length > 0 && createState < STATE_5_DANKESSEITE) {
            <div class="process">
                <div class="stepContainer">
                    <div class="step done"
                         [class.done]="createState > STATE_1_ANTRAGSTELLER"
                         [class.active]="createState === STATE_1_ANTRAGSTELLER"
                         (click)="setCreationState(STATE_1_ANTRAGSTELLER, false)">
                        <span>1. Antragsteller</span>
                    </div>
                    <div class="step done"
                         [class.done]="createState > STATE_2_AUFTRAGGEBER"
                         [class.active]="createState === STATE_2_AUFTRAGGEBER"
                         [class.inactive]="createState < STATE_2_AUFTRAGGEBER"
                         (click)="setCreationState(STATE_2_AUFTRAGGEBER, false)">
                        <span>2. Auftraggeber</span>
                    </div>
                    <div class="step active"
                         [class.done]="createState > STATE_3_BUERGSCHAFT"
                         [class.active]="createState === STATE_3_BUERGSCHAFT"
                         [class.inactive]="createState <  STATE_3_BUERGSCHAFT"
                         (click)="setCreationState(STATE_3_BUERGSCHAFT, false)">
                        <span>3. Bürgschaft</span>
                    </div>
                    <div class="step inactive"
                         [class.active]="createState === STATE_4_ABSCHLUSS"
                         [class.inactive]="createState < STATE_4_ABSCHLUSS">
                        <span>4. Abschlusserklärung</span>
                    </div>
                </div>
            </div>
        }
    </div>

    <!--  #####################################################  -->
    <!--  1. Antragsteller                                       -->
    <!--  #####################################################  -->
    <div [ngClass]="['gridContainer', 'formStep1', createState === STATE_1_ANTRAGSTELLER ? 'show' : 'hide']">

    @if (vertragHandles && vertragHandles.length > 0) {

        <h2>
            1. Antragsteller

            <div class="options">
                <span class="hinweis">* Pflichtfelder</span>
            </div>
        </h2>

        <div class="gridContainer formGrid fitGrid">

            <!-- Antragsteller Firma -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_firma">Firma:&nbsp;*</label>
                </div>
                <div class="cell grid-50">
                    <input type="text"
                           id="f_firma"
                           name="f_firma"
                           maxlength="79"
                           value=""
                           required
                           placeholder="Firma"
                           [(ngModel)]="model.firma.value"
                           [class.error]="model.firma.valid === false"
                           (blur)="validateField(model.firma)">
                    @if (model.firma.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.firma.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <!-- Antragsteller Vorname -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_vorname">Vorname:</label>
                </div>
                <div class="cell grid-50">
                    <input type="text"
                           id="f_vorname"
                           name="f_vorname"
                           maxlength="79"
                           value=""
                           placeholder="Vorname"
                           [(ngModel)]="model.vorname.value"
                           [class.error]="model.vorname.valid === false"
                           (blur)="validateField(model.vorname)">
                    @if (model.vorname.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.vorname.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <!-- Antragsteller Nachname -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_name">Name:</label>
                </div>
                <div class="cell grid-50">
                    <input type="text"
                           id="f_name"
                           name="f_name"
                           maxlength="79"
                           value=""
                           placeholder="Name"
                           [(ngModel)]="model.nachname.value"
                           [class.error]="model.nachname.valid === false"
                           (blur)="validateField(model.nachname)">
                    @if (model.nachname.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.nachname.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <!-- Antragsteller Straße, Hausnr. / Postfach -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_strasse_hausnummer_postfach">Straße, Hausnummer / Postfach:&nbsp;*</label>
                </div>
                <div class="cell grid-50">
                    <input type="text"
                           id="f_strasse_hausnummer_postfach"
                           name="f_strasse_hausnummer_postfach"
                           maxlength="79"
                           value=""
                           placeholder="Straße und Hausnummer oder Postfach"
                           required
                           [(ngModel)]="model.street.value"
                           [class.error]="model.street.valid === false"
                           (blur)="validateField(model.street)">
                    @if (model.street.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.street.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <!-- Antragsteller PLZ und Ort -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label">PLZ und Ort:&nbsp;*</label>
                </div>
                <div class="cell grid-20">
                    <input type="text"
                           id="f_plz"
                           name="f_plz"
                           maxlength="5"
                           value=""
                           placeholder="PLZ"
                           aria-label="PLZ"
                           required
                           [(ngModel)]="model.plz.value"
                           [class.error]="model.plz.valid === false"
                           (blur)="validateField(model.plz)">
                    @if (model.plz.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.plz.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-30">
                    <input type="text"
                           name="f_ort"
                           maxlength="79"
                           value=""
                           placeholder="Ort"
                           aria-label="Ort"
                           required
                           [(ngModel)]="model.ort.value"
                           [class.error]="model.ort.valid === false"
                           (blur)="validateField(model.ort)">
                    @if (model.ort.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.ort.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <!-- Antragsteller Telefonnummer -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Telefonnummer:</label>
                </div>
                <div class="cell grid-20">
                    <input type="text"
                           id="f_telefonnr_vorwahl"
                           name="f_telefonnr_vorwahl"
                           maxlength="10"
                           value=""
                           placeholder="Vorwahl"
                           aria-label="Vorwahl"
                           [(ngModel)]="model.vorwahl.value"
                           [class.error]="model.vorwahl.valid === false"
                           (blur)="validateField(model.vorwahl)">
                    @if (model.vorwahl.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.vorwahl.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-30">
                    <input type="text"
                           name="f_telefonnr_rufnummer"
                           maxlength="10"
                           value=""
                           placeholder="Rufnummer"
                           aria-label="Rufnummer"
                           [(ngModel)]="model.rufnummer.value"
                           [class.error]="model.rufnummer.valid === false"
                           (blur)="validateField(model.rufnummer)">
                    @if (model.rufnummer.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.rufnummer.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <!-- Antragsteller E-Mail-Adresse -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_email">E-Mail-Adresse:&nbsp;*</label>
                </div>
                <div class="cell grid-50">
                    <input type="text"
                           id="f_email"
                           name="f_email"
                           placeholder="E-Mail-Adresse"
                           maxlength="79"
                           [(ngModel)]="model.email.value"
                           [class.error]="model.email.valid === false"
                           (blur)="validateField(model.email)"/>
                    @if (model.email.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.email.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>

            <div class="row trenner"></div>

            <!-- Vertragsnummer -->
            <div class="row">
                <div class="cell grid-25 alignr" style="vertical-align: top">
                    <label class="field-label" for="f_kautionsvertrag">Vertragsnummer:&nbsp;*</label>
                </div>
                <div class="cell grid-50">
                    <select id="f_kautionsvertrag"
                            name="f_kautionsvertrag"
                            required
                            [(ngModel)]="model.vertrag.value"
                            [class.error]="model.vertrag.valid === false"
                            [disabled]="isVertragsListeDisabled()"
                            (change)="validateField(model.vertrag); onVertragChanged()">
                        @if (vertragHandles.length > 1) {
                            <option value="">Vertrag wählen &hellip;</option>
                        }
                        @for (vertrag of vertragHandles; track vertrag) {
                            <option [value]="formatVsnrRigid(vertrag.vsnrFormatiert)">{{ vertrag.vsnrFormatiert | formatVsnr }}</option>
                        }
                    </select>
                    @if (model.vertrag.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.vertrag.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25">
                </div>
            </div>

            <div class="row trenner">
            </div>

            <div class="row">
                <div class="cell grid-75"></div>

                <div class="cell grid-25">
                    <elem-button class="expand" (click)="setCreationState(STATE_2_AUFTRAGGEBER, true)">
                        Weiter
                    </elem-button>
                </div>
            </div>
        </div>
    } @else {
        <p>Die Beantragung einer neuen Bürgschaft ist nicht möglich. Es wurden keine Verträge gefunden.</p>
    }
    </div>

</div>

<!--  #####################################################  -->
<!--  2. Auftraggeber                                        -->
<!--  #####################################################  -->
<div [ngClass]="['gridContainer', 'formStep2', createState === STATE_2_AUFTRAGGEBER ? 'show' : 'hide']">

    <h2>
        2. Auftraggeber

        <div class="options">
            <span class="hinweis">* Pflichtfelder</span>
        </div>
    </h2>

    <div class="gridContainer formGrid fitGrid">

        <!-- Antragsart (Neuantrag / Änderungsantrag) -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label">Es handelt sich um einen:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="radio"
                       id="f_antragsart_neuantrag"
                       name="f_antragsart"
                       value="U"
                       [(ngModel)]="model.typeOfAntrag.value"
                       [class.error]="model.typeOfAntrag.valid === false"
                       (mouseup)="validateField(model.typeOfAntrag)">
                <label for="f_antragsart_neuantrag">Neuantrag</label>
            </div>
            <div class="cell grid-50">
                <input type="radio"
                       id="f_antragsart_aenderungsantrag"
                       name="f_antragsart"
                       value="N"
                       [(ngModel)]="model.typeOfAntrag.value"
                       [class.error]="model.typeOfAntrag.valid === false"
                       (mouseup)="validateField(model.typeOfAntrag)">
                <label for="f_antragsart_aenderungsantrag">Änderungsantrag</label>
            </div>
        </div>

        <!-- Bürgscheinnummer -->
        <!-- SICHTBAR wenn Antragsart == Änderungsantrag -->
        <div [ngClass]="['row', 'near', model.typeOfAntrag.value === 'N' ? 'show' : 'hide']">
            <div class="cell grid-50"></div>
            <div class="cell grid-50">
                <label for="f_antragsart_aenderungsantrag_vsnr">
                    Bürgscheinnummer:&nbsp;*
                </label>
            </div>
        </div>
        <div [ngClass]="['row', 'near', model.typeOfAntrag.value === 'N' ? 'show' : 'hide']">
            <div class="cell grid-50"></div>
            <div class="cell grid-25">
                @if (aenderungsBuergschaften && aenderungsBuergschaften.length > 0) {
                    <!--suppress XmlDuplicatedId -->
                    <select id="f_antragsart_aenderungsantrag_vsnr"
                            name="f_antragsart_aenderungsantrag_vsnr"
                            [(ngModel)]="model.aenderungsAntragBuergscheinNummer.value"
                            [class.error]="model.aenderungsAntragBuergscheinNummer.valid === false"
                            [disabled]="isAenderungsantragAuswahlGesperrt"
                            (blur)="validateField(model.aenderungsAntragBuergscheinNummer)">
                        <option value="" selected="selected">Bitte wählen &hellip;</option>
                        @for (aenderungsBuergschaft of aenderungsBuergschaften; track aenderungsBuergschaft) {
                            <option [value]="aenderungsBuergschaft">{{ aenderungsBuergschaft }}</option>
                        }
                    </select>
                } @else {
                    <!--suppress XmlDuplicatedId -->
                    <input id="f_antragsart_aenderungsantrag_vsnr"
                           name="f_antragsart_aenderungsantrag_vsnr"
                           type="text"
                           value="Keine Bürgschaft verfügbar"
                           title="Der zuvor gewählte Vertrag enthält keine (änderbare) Bürgschaft."
                           disabled>
                }
                @if (model.aenderungsAntragBuergscheinNummer.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.aenderungsAntragBuergscheinNummer.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Auftraggebertyp (Firma / Öffentlicher AG / Privat) -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label">Der Auftraggeber ist:&nbsp;*</label>
            </div>
            @if (model.isDigitaleBuergschaft) {
                <div class="cell grid-75">
                    <div class="text-vertical-center">{{ model.vertrittOeffentlicheRessorts ? AGTYP_OEFFENTLICH : AGTYP_FIRMA }}</div>
                </div>
            } @else {
                <div class="cell grid-25">
                    <input type="radio"
                           id="f_auftraggebertyp_firma"
                           name="f_auftraggebertyp"
                           [value]="AGTYP_FIRMA"
                           [(ngModel)]="model.auftraggeberTyp.value"
                           [class.error]="model.auftraggeberTyp.valid === false">
                    <label for="f_auftraggebertyp_firma">Firma</label>
                </div>
                <div class="cell grid-25">
                    <input type="radio"
                           id="f_auftraggebertyp_oeffentlich"
                           name="f_auftraggebertyp"
                           [value]="AGTYP_OEFFENTLICH"
                           [(ngModel)]="model.auftraggeberTyp.value"
                           [class.error]="model.auftraggeberTyp.valid === false">
                    <label for="f_auftraggebertyp_oeffentlich">Öffentlicher Auftraggeber</label>
                </div>
                <div class="cell grid-25">
                    <input type="radio"
                           id="f_auftraggebertyp_privatperson"
                           name="f_auftraggebertyp"
                           [value]="AGTYP_PRIVAT"
                           [(ngModel)]="model.auftraggeberTyp.value"
                           [class.error]="model.auftraggeberTyp.valid === false">
                    <label for="f_auftraggebertyp_privatperson">Privatperson</label>
                </div>
            }
        </div>

        <!-- Auftraggeber Name -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <!--suppress XmlInvalidId -->
                <label class="field-label" for="f_auftraggeber_name">Auftraggeber:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <auftraggeber-suche inputElemId="f_auftraggeber_name"
                                    maxlength="90"
                                    placeholder="Name des Auftraggebers"
                                    [fieldModel]="model.auftraggeberName"
                                    [disabled]="model.isDigitaleBuergschaft"
                                    [title]="getAuftraggeberFeldTitle()"
                                    (searchResultSelected)="onAuftraggeberSucheResultSelected($event)"
                                    (blur)="onAuftraggeberSucheBlur()"
                                    (change)="onAuftraggeberChanged()"></auftraggeber-suche>

                @if (model.isDigitaleBuergschaft) {
                    <elem-button
                        class="top-margin"
                        (click)="onAuftraggeberLoeschenClick()">
                        Eingabe löschen
                    </elem-button>
                }

                <!-- Info-Box -->
                @if (!model.isDigitaleBuergschaft) {
                    <div class="info-row top-margin">
                        <div class="info-row__icon">
                            <i class="icon ico-info pos-top-icon"></i>
                        </div>
                        <div class="info-row__text">Über die Auftraggebersuche wird geprüft, ob ihr Auftraggeber sich für die digitale Bürgschaft registriert hat.</div>
                    </div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Auftraggeber Straße und Hausnummer -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_auftraggeber_strasse_hausnummer">Straße und Hausnummer:&nbsp;*</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_auftraggeber_strasse_hausnummer"
                       name="f_auftraggeber_strasse_hausnummer"
                       maxlength="60"
                       value=""
                       placeholder="Straße, Hausnummer"
                       [(ngModel)]="model.auftraggeberStrasseNr.value"
                       [disabled]="model.isDigitaleBuergschaft"
                       [class.error]="model.auftraggeberStrasseNr.valid === false"
                       [title]="getAuftraggeberFeldTitle()"
                       (blur)="validateField(model.auftraggeberStrasseNr)">
                @if (model.auftraggeberStrasseNr.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.auftraggeberStrasseNr.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Auftraggeber PLZ und Ort -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label">PLZ und Ort:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <div class="inputContainer">
                    <input type="text"
                           id="f_auftraggeber_plz"
                           name="f_auftraggeber_plz"
                           maxlength="8"
                           value=""
                           placeholder="PLZ"
                           aria-label="PLZ"
                           [(ngModel)]="model.auftraggeberPlz.value"
                           [class.error]="model.auftraggeberPlz.valid === false"
                           [disabled]="model.isDigitaleBuergschaft"
                           [title]="getAuftraggeberFeldTitle()"
                           (blur)="onAuftraggeberPlzBlur()">
                    @if (model.auftraggeberPlz.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.auftraggeberPlz.errorMsg"></div>
                    }
                </div>
            </div>
            <div class="cell grid-25">
                <div class="inputContainer">
                    <input type="text"
                           id="f_auftraggeber_ort"
                           name="f_auftraggeber_ort"
                           maxlength="21"
                           value=""
                           placeholder="Ort"
                           aria-label="Ort"
                           [(ngModel)]="model.auftraggeberOrt.value"
                           [class.error]="model.auftraggeberOrt.valid === false"
                           [disabled]="model.isDigitaleBuergschaft"
                           [title]="getAuftraggeberFeldTitle()"
                           (blur)="validateField(model.auftraggeberOrt)">
                    @if (model.auftraggeberOrt.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.auftraggeberOrt.errorMsg"></div>
                    }
                </div>
            </div>
            <div class="cell grid-25">
            </div>
        </div>

        <!-- Auftraggeber Land -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label">Land:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <select id="f_auftraggeber_land"
                        name="f_auftraggeber_land"
                        [(ngModel)]="model.auftraggeberLand.value"
                        [class.error]="model.auftraggeberLand.valid === false"
                        [disabled]="model.isDigitaleBuergschaft"
                        [title]="getAuftraggeberFeldTitle()"
                        (change)="onAuftraggeberLandChanged()">
                    @for (land of auftraggeberLaender; track land) {
                        <option [value]="land.kuerzel">{{ land.name }}</option>
                    }
                </select>
            </div>
            <div class="cell grid-25">
            </div>
        </div>

        <!-- Vertretungsformel -->

        <div [ngClass]="['row', 'trenner', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH ? 'show' : 'hide']"></div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label">Vertretungsformel:</label>
            </div>
            <div class="cell grid-75">
                <input type="checkbox"
                       name="f_vertretungsformel_vorhanden"
                       id="f_vertretungsformel_vorhanden"
                       [(ngModel)]="model.vertretungsformelChecked"
                       (change)="onVertretungsformelVorhandenChanged()"/>
                <label for="f_vertretungsformel_vorhanden">
                    <span style="width: auto">Vertretungsformel vorhanden?&nbsp;</span>
                    <elem-tooltip text="Verfügbar für folgende Bürgschaftsarten: Mängelansprüchebürgschaft, Vertragserfüllungsbürgschaft, Vorauszahlungsbürgschaft"></elem-tooltip>
                </label>
            </div>
        </div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH && model.vertretungsformelChecked ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertretungsformel_1">Hauptauftraggeber:&nbsp;*</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_vertretungsformel_1"
                       name="f_vertretungsformel_1"
                       maxlength="80"
                       placeholder="Zeile 1"
                       required
                       [(ngModel)]="model.vertretungsformel1.value"
                       [class.error]="model.vertretungsformel1.valid === false"
                       (blur)="validateField(model.vertretungsformel1)">
                @if (model.vertretungsformel1.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertretungsformel1.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH && model.vertretungsformelChecked ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertretungsformel_2">vertreten durch:</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_vertretungsformel_2"
                       name="f_vertretungsformel_2"
                       maxlength="80"
                       placeholder="Zeile 2"
                       [(ngModel)]="model.vertretungsformel2.value"
                       [class.error]="model.vertretungsformel2.valid === false"
                       (blur)="validateField(model.vertretungsformel2)">
                @if (model.vertretungsformel2.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertretungsformel2.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH && model.vertretungsformelChecked ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertretungsformel_3">vertreten durch:</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_vertretungsformel_3"
                       name="f_vertretungsformel_3"
                       maxlength="80"
                       placeholder="Zeile 3"
                       [(ngModel)]="model.vertretungsformel3.value"
                       [class.error]="model.vertretungsformel3.valid === false"
                       (blur)="validateField(model.vertretungsformel3)">
                @if (model.vertretungsformel3.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertretungsformel3.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH && model.vertretungsformelChecked ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertretungsformel_4">vertreten durch:</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_vertretungsformel_4"
                       name="f_vertretungsformel_4"
                       maxlength="80"
                       placeholder="Zeile 4"
                       [(ngModel)]="model.vertretungsformel4.value"
                       [class.error]="model.vertretungsformel4.valid === false"
                       (blur)="validateField(model.vertretungsformel4)">
                @if (model.vertretungsformel4.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertretungsformel4.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH && model.vertretungsformelChecked ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertretungsformel_5">vertreten durch:</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_vertretungsformel_5"
                       name="f_vertretungsformel_5"
                       maxlength="80"
                       placeholder="Zeile 5"
                       [(ngModel)]="model.vertretungsformel5.value"
                       [class.error]="model.vertretungsformel5.valid === false"
                       (blur)="validateField(model.vertretungsformel5)">
                @if (model.vertretungsformel5.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertretungsformel5.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div [ngClass]="['row', model.auftraggeberTyp.value === AGTYP_OEFFENTLICH && model.vertretungsformelChecked ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertretungsformel_letztlich">letztlich vertreten durch:</label>
            </div>
            <div class="cell grid-50" style="position: relative">
                <input type="text"
                       id="f_vertretungsformel_letztlich"
                       name="f_vertretungsformel_letztlich"
                       [value]="model.auftraggeberName.value"
                       disabled>
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div class="row trenner" [ngClass]="['row', model.forcedDigitalAuftraggebers.length ? 'show' : 'hide']"></div>

        <div [ngClass]="['row', model.forcedDigitalAuftraggebers.length ? 'show' : 'hide']">
            <div class="cell grid-25"></div>
            <div class="cell grid-50">
                <div>
                    Der angegebene Auftraggeber könnte für den Empfang von digitalen Bürgschaften über Trustlog
                    registriert sein. Bitte prüfen Sie, ob Ihr Auftraggeber bei den aufgeführten Daten enthalten ist.
                </div>

                @for (fAuftraggeber of model.forcedDigitalAuftraggebers; track fAuftraggeber) {
                    <div style="margin-top: 1rem">
                        <input type="radio"
                               name="f_auftraggeber_suggestion"
                               [id]="'f_auftraggeber_suggestion_' + fAuftraggeber.spKennung"
                               [value]="fAuftraggeber.spKennung"
                               [(ngModel)]="model.forcedAuftraggeberValidator.value"
                               [class.error]="model.forcedAuftraggeberValidator.valid === false"
                               (click)="onSelectForcedAuftraggeber(fAuftraggeber)">
                        <label [for]="'f_auftraggeber_suggestion_' + fAuftraggeber.spKennung" style="float: unset">
                            {{ fAuftraggeber.name }}, {{ fAuftraggeber.landeskennzeichen }}-{{ fAuftraggeber.plz }} {{ fAuftraggeber.ort }}
                        </label>
                    </div>
                }

                <div style="margin-top: 1rem">
                    <input type="radio"
                           name="f_auftraggeber_suggestion"
                           id="f_auftraggeber_suggestion_manuell"
                           value="manuell"
                           [(ngModel)]="model.forcedAuftraggeberValidator.value"
                           [class.error]="model.forcedAuftraggeberValidator.valid === false"
                           (click)="onSelectForcedAuftraggeber(forcedAuftraggeberInputBackup)">
                    <label for="f_auftraggeber_suggestion_manuell" style="float: unset">Mit meinen Daten fortfahren und <strong>keine</strong> digitale Bürgschaft beantragen</label>
                </div>
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div class="row trenner"></div>

        <div class="row">
            <div class="cell grid-25">
                <elem-button buttonRole="TERTIARY" class="expand" (click)="setCreationState(STATE_1_ANTRAGSTELLER, false)">
                    Zurück
                </elem-button>
            </div>
            <div class="cell grid-50">
            </div>
            <div class="cell grid-25">
                <elem-button class="expand"
                             (click)="setCreationState(STATE_3_BUERGSCHAFT, true)"
                             [disabled]="isForcedDigitalAuftraggeberCheckPending">
                    Weiter
                </elem-button>
            </div>
        </div>

    </div>
</div>

<!--  #####################################################  -->
<!--  3. Bürgschaft                                          -->
<!--  #####################################################  -->
<div [ngClass]="['gridContainer', 'formStep3', createState === STATE_3_BUERGSCHAFT ? 'show' : 'hide']">

    <h2>
        3. Bürgschaft

        <div class="options">
            <span class="hinweis">* Pflichtfelder</span>
        </div>
    </h2>

    <div class="gridContainer formGrid fitGrid">

        <!-- Bürgschaftsart -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_buergschaftsart">Bitte Bürgschaftsart wählen:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <select id="f_buergschaftsart"
                        name="f_buergschaftsart"
                        [(ngModel)]="model.buergschaftsArt.value"
                        [class.error]="model.buergschaftsArt.valid === false"
                        (change)="onBuergschaftsArtChanged()">
                    <option value="" selected="selected">Bürgschaftsart wählen &hellip;</option>
                    <option value="AF">Ausführungsbürgschaft</option>
                    <option value="VE">Vertragserfüllungsbürgschaft</option>
                    <option value="MA">Mängelansprüchebürgschaft</option>
                    <option value="BI">Bietungsbürgschaft</option>
                    <option value="BS">Bauhandwerkersicherungsbürgschaft (gem. §650f BGB)</option>
                    <option value="VA">Vorauszahlungsbürgschaft</option>
                </select>
                @if (model.buergschaftsArt.valid === false) {
                    <div
                        class="errorText"
                        style="margin-top: 1rem"
                        [innerHTML]="model.buergschaftsArt.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Voraussichtliches Datum der Fertigstellung der Bauleistungen -->
        <!-- SICHTBAR wenn Bürgschaftsart == Ausführungsbürgschaft -->
        <div [ngClass]="['row', model.buergschaftsArt.value === 'AF' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_ausfuehrungs_bs_datum">Voraussichtliches Datum der Fertigstellung der Bauleistungen:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_ausfuehrungs_bs_datum"
                       name="f_art_ausfuehrungs_bs_datum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.ausfuehrungsbuergschaftenDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.ausfuehrungsbuergschaftenDatum, $event)"
                       [class.error]="model.ausfuehrungsbuergschaftenDatum.valid === false"
                       (blur)="validateField(model.ausfuehrungsbuergschaftenDatum)">
                @if (model.ausfuehrungsbuergschaftenDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.ausfuehrungsbuergschaftenDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- Voraussichtliches Datum der Abnahme der Bauleistungen -->
        <!-- SICHTBAR wenn Bürgschaftsart == Vertragserfüllungsbürgschaft -->
        <div [ngClass]="['row', model.buergschaftsArt.value === 'VE' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_vertragserfuellungs_bs_datum">Voraussichtliches Datum der Abnahme der Bauleistungen:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_vertragserfuellungs_bs_datum"
                       name="f_art_vertragserfuellungs_bs_datum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.vertragserfuellungsbuergschaftenDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.vertragserfuellungsbuergschaftenDatum, $event)"
                       [class.error]="model.vertragserfuellungsbuergschaftenDatum.valid === false"
                       (blur)="validateField(model.vertragserfuellungsbuergschaftenDatum)">
                @if (model.vertragserfuellungsbuergschaftenDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertragserfuellungsbuergschaftenDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- Datum der Abnahme der Bauleistungen ODER Schlussrechnungs-Datum -->
        <!-- SICHTBAR wenn Bürgschaftsart == Mängelansprüchebürgschaft -->
        <div [ngClass]="['row', model.buergschaftsArt.value === 'MA' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_maengelansprueche_bs_abnahmedatum">Datum der Abnahme der Bauleistungen:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_maengelansprueche_bs_abnahmedatum"
                       name="f_art_maengelansprueche_bs_abnahmedatum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.gewaehrleistungsbuergschaftenDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.gewaehrleistungsbuergschaftenDatum, $event)"
                       [class.error]="model.gewaehrleistungsbuergschaftenDatum.valid === false"
                       (blur)="validateField(model.gewaehrleistungsbuergschaftenDatum)">
                @if (model.gewaehrleistungsbuergschaftenDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.gewaehrleistungsbuergschaftenDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>
        <div [ngClass]="['row', 'near', model.buergschaftsArt.value === 'MA' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label>oder</label>
            </div>
            <div class="cell grid-25"></div>
            <div class="cell grid-50"></div>
        </div>
        <div [ngClass]="['row', 'near', model.buergschaftsArt.value === 'MA' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_maengelansprueche_bs_schlussrechnungsdatum">Schlussrechnungs-Datum:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_maengelansprueche_bs_schlussrechnungsdatum"
                       name="f_art_maengelansprueche_bs_schlussrechnungsdatum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.schlussrechnungsDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.schlussrechnungsDatum, $event)"
                       [class.error]="model.schlussrechnungsDatum.valid === false"
                       (blur)="validateField(model.schlussrechnungsDatum)">
                @if (model.schlussrechnungsDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.schlussrechnungsDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- Datum des Ablaufs der Zuschlagfrist -->
        <!-- SICHTBAR wenn Bürgschaftsart == Bietungsbürgschaft -->
        <div [ngClass]="['row', model.buergschaftsArt.value === 'BI' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_bietungs_bs_datum">Datum des Ablaufs der Zuschlagfrist:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_bietungs_bs_datum"
                       name="f_art_bietungs_bs_datum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.bietungsbuergschaftenDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.bietungsbuergschaftenDatum, $event)"
                       [class.error]="model.bietungsbuergschaftenDatum.valid === false"
                       (blur)="validateField(model.bietungsbuergschaftenDatum)">
                @if (model.bietungsbuergschaftenDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.bietungsbuergschaftenDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- Voraussichtliches Datum der Abnahme der Bauleistungen -->
        <!-- SICHTBAR IF Bürgschaftsart == 	Bauhandwerkersicherungsbürgschaft -->
        <div [ngClass]="['row', model.buergschaftsArt.value === 'BS' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_bauhandwerksversicherungs_bs_datum">Voraussichtliches Datum der Abnahme der Bauleistungen:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_bauhandwerksversicherungs_bs_datum"
                       name="f_art_bauhandwerksversicherungs_bs_datum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.bauhandwerkersicherungssbuergschaftenDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.bauhandwerkersicherungssbuergschaftenDatum, $event)"
                       [class.error]="model.bauhandwerkersicherungssbuergschaftenDatum.valid === false"
                       (blur)="validateField(model.bauhandwerkersicherungssbuergschaftenDatum)">
                @if (model.bauhandwerkersicherungssbuergschaftenDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.bauhandwerkersicherungssbuergschaftenDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- Voraussichtliches Datum der Fertigstellung der Bauleistungen -->
        <!-- SICHTBAR wenn Bürgschaftsart == Vorauszahlungsbürgschaft -->
        <div [ngClass]="['row', model.buergschaftsArt.value === 'VA' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_art_vorauszahlungs_bs_datum">Voraussichtliches Datum der Fertigstellung der Bauleistungen:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_art_vorauszahlungs_bs_datum"
                       name="f_art_vorauszahlungs_bs_datum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.vorauszahlungsbuergschaftenDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.vorauszahlungsbuergschaftenDatum, $event)"
                       [class.error]="model.vorauszahlungsbuergschaftenDatum.valid === false"
                       (blur)="validateField(model.vorauszahlungsbuergschaftenDatum)">
                @if (model.vorauszahlungsbuergschaftenDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vorauszahlungsbuergschaftenDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <div class="row trenner"></div>

        <!-- Vertrag/Auftrag vom -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertrags_auftrags_datum">Vertrag/Auftrag vom:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="date"
                       id="f_vertrags_auftrags_datum"
                       name="f_vertrags_auftrags_datum"
                       value=""
                       placeholder="TT.MM.JJJJ"
                       [ngModel]="model.vertragsDatum.value | dateValue2DateInputPipe"
                       (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.vertragsDatum, $event)"
                       [class.error]="model.vertragsDatum.valid === false"
                       (blur)="validateVertragsdatum(model.vertragsDatum)">
                @if (model.vertragsDatum.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertragsDatum.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- Vertrags-/Auftragsnummer -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_vertragsnummer">Vertrags-/Auftragsnummer:</label>
            </div>
            <div class="cell grid-25">
                <input type="text"
                       id="f_vertragsnummer"
                       name="f_vertragsnummer"
                       value=""
                       maxlength="30"
                       placeholder="Bitte eingeben..."
                       [(ngModel)]="model.vertragsnummer.value"
                       [class.error]="model.vertragsnummer.valid === false"
                       (blur)="validateField(model.vertragsnummer)">
                @if (model.vertragsnummer.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.vertragsnummer.errorMsg"></div>
                }
            </div>
            <div class="cell grid-50"></div>
        </div>

        <!-- ---------------------------------- -->
        <!-- Formulartext / Bürgschaftstemplate -->
        <!-- ---------------------------------- -->
        @if (model.buergschaftsArt.value && vertragsdatumEntered) {
            <div [ngClass]="['row', 'trenner', model.buergschaftsArt.value ? 'show' : 'hide']"></div>
            <!-- Digitale Bürgschaft -->
            <div [ngClass]="['row', model.buergschaftsArt.value && model.isDigitaleBuergschaft && !model.moechteAbweichendenBuergschaftstext ? 'show' : 'hide']">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_buergschaftstext">Bürgschaftstext:</label>
                </div>
                <div class="cell grid-50">
                    @if (bspTemplates.length > 0) {
                        <!-- Bürgschaftstext -->
                        <select id="f_buergschaftstext"
                                name="f_buergschaftstext"
                                [(ngModel)]="model.templateSpKennung.value"
                                [class.error]="model.templateSpKennung.valid === false"
                                [class.hide]="bspTemplates.length <= 1"
                                [disabled]="bspTemplates.length === 1"
                                (change)="validateField(model.templateSpKennung); templateUpdated()">
                            @if (bspTemplates.length > 1) {
                                <option value="">Bitte wählen Sie einen Text &hellip;</option>
                            }
                            @for (bsTemplate of bspTemplates; track bsTemplate) {
                                <option [value]="bsTemplate.spKennung">{{ getLabel(bsTemplate) }}</option>
                            }
                        </select>
                        @if (model.templateSpKennung.valid === false) {
                            <div
                                class="errorMessage"
                                [innerHTML]="model.templateSpKennung.errorMsg"></div>
                        }
                        <!-- Info-Box über ausgewählten Bürgschaftstext -->
                        @if (selectedBspTemplate) {
                            <div class="bstext__box" [class.top-margin]="bspTemplates.length > 1">
                                <div class="row-flex">
                                    <div class="bstext__box__icon">
                                        <img src="../../../../../assets/img/icons/contract.svg" alt="Dokument-Icon">
                                    </div>
                                    <div>
                                        <div class="bstext__box__title">
                                            @switch (model.buergschaftsArt.value) {
                                                @case ('AF') {
                                                    Ausführungsbürgschaft
                                                }
                                                @case ('VE') {
                                                    Vertragserfüllungsbürgschaft
                                                }
                                                @case ('MA') {
                                                    Mängelansprüchebürgschaft
                                                }
                                                @case ('VA') {
                                                    Vorauszahlungsbürgschaft
                                                }
                                            }
                                        </div>
                                        <div class="bstext__box__subtitle">
                                            <span>{{ model.auftraggeberName.valid ? model.auftraggeberName.value : 'Name des Auftraggebers' }}, </span>
                                            <span>{{ selectedBspTemplate.beschreibungAuftraggeber }}</span>
                                        </div>
                                    </div>
                                    <div class="row-flex__align-right">
                                        <elem-button buttonRole="SMALL"
                                                     icon="icon-attachements"
                                                     [disabled]="getVorschauBtnDisablesStatus()"
                                                     (click)="onVorschauTemplateClick()">Vorschau
                                        </elem-button>
                                    </div>
                                </div>
                                <div class="bstext__box__separator"></div>
                                <div class="info-row top-margin">
                                    <div class="info-row__icon">
                                        <img src="../../../../../assets/img/icons/mailing_check.svg" alt="Häkchen">
                                    </div>
                                    <div class="info-row__text">
                                        Hinweis: Ihr Auftraggeber hat uns diesen Text zur Verfügung gestellt.
                                        Bitte beachten Sie, dass die Bürgschaft dem Auftraggeber ausschließlich digital zur Verfügung gestellt wird.
                                    </div>
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="bstext__hinweis-box">
                            <div class="info-row__icon">
                                <img src="../../../../../assets/img/icons/warning.svg" alt="Warnung">
                            </div>
                            <div class="info-row__text"><strong>Hinweis:</strong> Der Auftraggeber hat noch kein Formular zur Verfügung gestellt, welches der gewünschten Bürgschaft entspricht. Bitte wählen Sie ein abweichendes Formular aus.</div>
                        </div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>
            <!-- Checkbox "Ich möchte einen abweichenden Bürgschaftstext angeben" -->
            <div [ngClass]="['row', model.buergschaftsArt.value && model.isDigitaleBuergschaft && selectedBspTemplate ? 'show' : 'hide']">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Abweichender Bürgschaftstext:</label>
                </div>
                <div class="cell grid-50">
                    <input type="checkbox"
                           id="f_abweichender_buergschaftstext"
                           name="f_abweichender_buergschaftstext"
                           value="moechteAbweichendenBuergschaftstext"
                           [(ngModel)]="model.moechteAbweichendenBuergschaftstext"
                           (change)="onMoechteAbweichendenBuergschaftstextChanged()">
                    <label for="f_abweichender_buergschaftstext">Ich möchte einen abweichenden Bürgschaftstext angeben</label>
                </div>
                <div class="cell grid-25"></div>
            </div>
            <!-- Gewünschtes Formular -->
            <div [ngClass]="['row', model.buergschaftsArt.value && (!model.isDigitaleBuergschaft || !selectedBspTemplate || model.moechteAbweichendenBuergschaftstext) ? 'show' : 'hide']">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_gewuenschtes_formular">Gewünschtes Formular:&nbsp;*</label>
                </div>
                <div class="cell grid-50">
                    @if (model.isDigitaleBuergschaft && selectedBspTemplate && model.moechteAbweichendenBuergschaftstext) {
                        <div
                            class="bstext__hinweis-box"
                            style="margin-bottom: 1rem">
                            <div class="info-row__icon">
                                <img src="../../../../../assets/img/icons/warning.svg" alt="Warnung">
                            </div>
                            <div class="info-row__text"><strong>Hinweis:</strong>
                                Ihr Auftraggeber akzeptiert in der Regel nur das vorgeschlagene Formular.
                                Bitte prüfen Sie Ihren Vertrag bevor Sie ein anderes Formular verwenden.
                            </div>
                        </div>
                    }
                    <select name="f_formularart"
                            id="f_gewuenschtes_formular"
                            [(ngModel)]="model.gewuenschtesFormular.value"
                            [class.error]="model.gewuenschtesFormular.valid===false"
                            (change)="validateField(model.gewuenschtesFormular); onGewuenschtesFormularChanged()">
                        <option value="" selected="selected">Bitte wählen Sie einen Text &hellip;</option>
                        @for (formType of visibleFormulare; track formType) {
                            <option [value]="formType.left">{{ formType.right }}</option>
                        }
                    </select>
                    @if (model.gewuenschtesFormular.valid === false) {
                        <div
                            class="errorText"
                            style="margin-top: 1rem"
                            [innerHTML]="model.gewuenschtesFormular.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>
            <!-- Gewünschte Bürgschaftszusätze -->
            @if (isGewuenschteZusaetzeMoeglich()) {
                <div class="row">
                    <div class="cell grid-25 alignr">
                        <label class="field-label">Gewünschte Bürgschaftszusätze:</label>
                    </div>
                    <!-- Hinterlegung -->
                    <div class="cell grid-25">
                        <input type="checkbox"
                               name="f_buergschaftszusaetze"
                               value="hinterlegung"
                               id="f_buergschaftszusaetze_hinterlegung"
                               [(ngModel)]="model.checkboxHinterlegung.value"
                               (change)="this.updateShowVersandartAuswahl()">
                        <label for="f_buergschaftszusaetze_hinterlegung">Hinterlegung
                            <elem-tooltip text="Eine Befreiung durch Hinterlegung des Bürgschaftsbetrages ist ausgeschlossen. Der Bürge kann damit die Auszahlung aus der Bürgschaft nicht durch Hinterlegung bei Gericht abwenden."></elem-tooltip>
                        </label>
                    </div>
                    <div class="cell grid-25"></div>
                </div>
                <div class="row">
                    <div class="cell grid-25 alignr"></div>
                    <!-- § 768 BGB -->
                    <div class="cell grid-25">
                        <input type="checkbox"
                               name="f_buergschaftszusaetze"
                               value="BGB768"
                               id="f_buergschaftszusaetze_para768bgb"
                               [(ngModel)]="model.checkboxBGB768.value"
                               (change)="this.updateShowVersandartAuswahl()">
                        <label for="f_buergschaftszusaetze_para768bgb">§ 768 BGB
                            <elem-tooltip text="Wir verzichten auf die Rechte aus § 768. Damit sind dem Bürgen die Einreden des Auftragnehmers nicht möglich, sondern lediglich die eigenen. Dies betrifft insbesondere die Einrede der Verjährung der Hauptschuld. Dieser Zusatz erhöht das Risiko des Auftragnehmers und des Bürgen."></elem-tooltip>
                        </label>
                    </div>
                    <div class="cell grid-50"></div>
                </div>
                <div class="row">
                    <div class="cell grid-25 alignr"></div>
                    <!-- Weitere Bürgschaftszusätze -->
                    <div class="cell grid-50">
                        <div class="bstext__abweichend-accordion"
                             (click)="weitereBuergschaftszusaetze = !weitereBuergschaftszusaetze"
                             (change)="this.updateShowVersandartAuswahl()">
                            <button type="button"
                                    class="bstext__accordion-btn"
                                    [class.bstext__accordion-btn--expanded]="weitereBuergschaftszusaetze"
                                    [class.bstext__accordion-btn--shrinked]="!weitereBuergschaftszusaetze">
                            </button>
                            <span class="bstext__accordion-btn__label">Weitere Bürgschaftszusätze</span>
                        </div>
                    </div>
                    <div class="cell grid-25 alignr"></div>
                </div>
                @if (isWeitereBuergschaftszusaetze()) {
                    <div class="row">
                        <div class="cell grid-25 alignr"></div>
                        <!-- § 150 Abs. 3 SGB VII -->
                        <div class="cell grid-25">
                            <input type="checkbox"
                                   name="f_buergschaftszusaetze"
                                   value="SGBVII150Abs3"
                                   id="f_buergschaftszusaetze_SGBVII150Abs3"
                                   [(ngModel)]="model.checkboxSGBVII150Abs3.value"
                                   (change)="this.updateShowVersandartAuswahl()">
                            <label for="f_buergschaftszusaetze_SGBVII150Abs3">§ 150 Abs. 3 SGB VII
                                <elem-tooltip text="Nach § 150 Abs. 3 SGB VII ist der Unternehmer in der gesetzlichen Unfallversicherung alleiniger Beitragszahler. Für die Beitragshaftung bei der Ausführung eines Dienst- oder Werkvertrages im Baugewerbe gelten § 28 e Abs. 3a bis 3f."></elem-tooltip>
                            </label>
                        </div>
                        <!-- § 28 e Abs 3a SGB IV -->
                        <div class="cell grid-25">
                            <input type="checkbox"
                                   name="f_buergschaftszusaetze"
                                   value="SGBIV28eAbs3a"
                                   id="f_buergschaftszusaetze_SGBIV28eAbs3a"
                                   [(ngModel)]="model.checkboxSGBIV28eAbs3a.value"
                                   (change)="this.updateShowVersandartAuswahl()">
                            <label for="f_buergschaftszusaetze_SGBIV28eAbs3a">§ 28 e Abs 3a SGB IV
                                <elem-tooltip text="Nach § 28 e Abs 3a SGB IV haftet der Hauptunternehmer für die Erfüllung der Zahlungspflicht des Gesamtsozialversicherungsbeitrags eines von ihm mit der Erbringung von Bauleistungen beauftragten Nachunternehmers (Subunternehmers) wie ein selbstschuldnerischer Bürge. Voraussetzung ist, dass der geschätzte Gesamtwert aller für ein Bauwerk in Auftrag gegebenen Bauleistungen 275.000,00 EUR oder höher beträgt."></elem-tooltip>
                            </label>
                        </div>
                        <div class="cell grid-25"></div>
                    </div>
                    <div class="row">
                        <div class="cell grid-25 alignr"></div>
                        <!-- Sicherheitseinbehalt -->
                        <div class="cell grid-25">
                            <input type="checkbox"
                                   name="f_buergschaftszusaetze"
                                   value="Sicherheitseinbehalt"
                                   id="f_buergschaftszusaetze_Sicherheitseinbehalt"
                                   [(ngModel)]="model.checkboxSicherheitseinbehalt.value"
                                   (change)="this.updateShowVersandartAuswahl()">
                            <label for="f_buergschaftszusaetze_Sicherheitseinbehalt">Sicherheitseinbehalt
                                <elem-tooltip text="Diese Bürgschaft wird wirksam, sobald der abzulösende Sicherheitseinbehalt auf einem der Bankkonten der Firma vorbehaltlos eingegangen ist."></elem-tooltip>
                            </label>
                        </div>
                        <!-- § 14 AentG -->
                        <div class="cell grid-25">
                            <input type="checkbox"
                                   name="f_buergschaftszusaetze"
                                   value="AentG14"
                                   id="f_buergschaftszusaetze_AentG14"
                                   [(ngModel)]="model.checkboxAentG14.value"
                                   (change)="this.updateShowVersandartAuswahl()">
                            <label for="f_buergschaftszusaetze_AentG14">§ 14 AentG
                                <elem-tooltip text="§ 14 AentG regelt, dass ein Unternehmer, der einen anderen Unternehmer mit der Erbringung von Werk- oder Dienstleistungen beauftragt hat, für die Verpflichtungen dieses Unternehmers, eines Nachunternehmers oder eines von dem Unternehmer oder einem Nachunternehmer beauftragten Verleihers zur Zahlung des Mindestentgelts wie ein Bürge der auf die Einrede der Vorausklage verzichtet hat, haftet."></elem-tooltip>
                            </label>
                        </div>
                        <div class="cell grid-25"></div>
                    </div>
                }
            }
            <!-- Formular-Upload -->
                <!-- SICHTBAR wenn Formularart == Formular des Auftraggebers -->
            <div [ngClass]="['row', isFormularUploadVisible() ? 'show' : 'hide']">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Dateien anhängen:&nbsp;*</label>
                </div>
                <div class="cell grid-50">
                    <div>
                        <elem-file-upload #uploadField0
                                          [errorMessage]="errorMessages[0]"
                                          (fileSelected)="onFileUploadSelected(0, $event)"
                                          (fileUnselected)="onFileUploadUnselected(0)"></elem-file-upload>
                    </div>
                    <div style="margin: 1rem 0">
                        <elem-file-upload #uploadField1
                                          [errorMessage]="errorMessages[1]"
                                          (fileSelected)="onFileUploadSelected(1, $event)"
                                          (fileUnselected)="onFileUploadUnselected(1)"></elem-file-upload>
                    </div>
                    <div>
                        <elem-file-upload #uploadField2
                                          [errorMessage]="errorMessages[2]"
                                          (fileSelected)="onFileUploadSelected(2, $event)"
                                          (fileUnselected)="onFileUploadUnselected(2)"></elem-file-upload>
                    </div>
                </div>
                <div class="cell grid-25"></div>
            </div>
            <div [ngClass]="['row', (isFormularUploadVisible() && showNoUploadMessage) ? 'show' : 'hide']">
                <div class="cell grid-25"></div>
                <div class="cell grid-75">
                    @if (!isFileSelected()) {
                        <div class="errorLabel">
                            Bitte Datei anhängen.
                        </div>
                    }
                </div>
            </div>
            <div class="row trenner"></div>
            <!-- Bürgschaftsbetrag -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_buergschein_hoehe_zahl">Bürgschaftsbetrag:&nbsp;*</label>
                </div>
                <div class="cell grid-25">
                    <input type="text"
                           maxlength="13"
                           id="f_buergschein_hoehe_zahl"
                           name="f_buergschein_hoehe_zahl"
                           value=""
                           placeholder="Betragshöhe"
                           required
                           [(ngModel)]="model.buergschaftshoehe.value"
                           [class.error]="model.buergschaftshoehe.valid === false"
                           (blur)="validateField(model.buergschaftshoehe)">
                    @if (model.buergschaftshoehe.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.buergschaftshoehe.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-50">
                    <label>EUR</label>
                </div>
            </div>
            <!-- Hinweis Änderungsantrag-->
                <!-- SICHTBAR wenn Antragsart == Änderungsantrag -->
            @if (model.typeOfAntrag.value === 'N') {
                <div class="row">
                    <div class="cell grid-25"></div>
                    <div class="cell grid-75">
                        <label>Bitte beachten Sie, dass bei Änderungen zu Bürgschaften aus Vorjahren keine Betragserhöhung möglich ist.</label>
                    </div>
                </div>
            }
            <!-- [Bürgschaftsbetrag] entspricht x % der Bausumme -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label" for="f_buergschein_hoehe_prozentsatz_bausumme">entspricht:&nbsp;*</label>
                </div>
                <div class="cell grid-25">
                    <input type="text"
                           id="f_buergschein_hoehe_prozentsatz_bausumme"
                           name="f_buergschein_hoehe_prozentsatz_bausumme"
                           maxlength="6"
                           value=""
                           placeholder="Prozentsatz"
                           [(ngModel)]="model.prozentSatz.value"
                           [class.error]="model.prozentSatz.valid === false"
                           (blur)="validateField(model.prozentSatz)">
                    @if (model.prozentSatz.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.prozentSatz.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-50">
                    <label>% der Bausumme</label>
                </div>
            </div>
            <div class="row trenner"></div>
            <!-- Bürgschaften befristen / nicht befristen -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Die Bürgschaft ist:&nbsp;*</label>
                </div>
                <div class="cell grid-25">
                    <input type="radio"
                           name="f_buergschaft_befristung"
                           id="f_buergschaft_befristung_nein"
                           value="unbefristet"
                           [(ngModel)]="model.frist.value"
                           [class.error]="model.frist.valid === false"
                           [disabled]="nurBefristet === true">
                    <label for="f_buergschaft_befristung_nein">nicht zu befristen</label>
                </div>
                <div class="cell grid-50">
                    <input type="radio"
                           name="f_buergschaft_befristung"
                           id="f_buergschaft_befristung_ja"
                           value="befristet"
                           [(ngModel)]="model.frist.value"
                           [class.error]="model.frist.valid === false"
                           [disabled]="nurUnbefristet === true">
                    <label for="f_buergschaft_befristung_ja">zu befristen bis</label>
                </div>
            </div>
            <!-- SICHTBAR wenn Bürgschaft zu befristen -->
            <div [ngClass]="['row', model.frist.value === 'befristet' ? 'show' : 'hide']">
                <div class="cell grid-50"></div>
                <div class="cell grid-25">
                    <input type="date"
                           id="f_buergschaft_befristung_datum"
                           name="f_buergschaft_befristung_datum"
                           value=""
                           placeholder="TT.MM.JJJJ"
                           aria-label="Befristungsdatum"
                           [ngModel]="model.fristDatum.value | dateValue2DateInputPipe"
                           (ngModelChange)="dateUtilsService.convertInputDate2ReadableDate(model.fristDatum, $event)"
                           [class.error]="model.fristDatum.valid === false"
                           (blur)="validateField(model.fristDatum)">
                    @if (model.fristDatum.valid === false) {
                        <div
                            class="errorMessage"
                            [innerHTML]="model.fristDatum.errorMsg"></div>
                    }
                </div>
                <div class="cell grid-25"></div>
            </div>
            <div class="row trenner"></div>
            <!-- Rechtsgrundlage VOB / BGB -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Rechtsgrundlage:&nbsp;*</label>
                </div>
                <div class="cell grid-25">
                    <input type="radio"
                           id="f_bauvertrag_rechtsgrundlage_vob"
                           name="f_bauvertrag_rechtsgrundlage"
                           value="VOB"
                           [(ngModel)]="model.gesetzlGrundlage.value"
                           [class.error]="model.gesetzlGrundlage.valid === false"
                           (mouseup)="validateField(model.gesetzlGrundlage)">
                    <label for="f_bauvertrag_rechtsgrundlage_vob">VOB vereinbart</label>
                </div>
                <div class="cell grid-50">
                    <input type="radio"
                           id="f_bauvertrag_rechtsgrundlage_bgb"
                           name="f_bauvertrag_rechtsgrundlage"
                           value="BGB"
                           [(ngModel)]="model.gesetzlGrundlage.value"
                           [class.error]="model.gesetzlGrundlage.valid === false"
                           (mouseup)="validateField(model.gesetzlGrundlage)">
                    <label for="f_bauvertrag_rechtsgrundlage_bgb">BGB vereinbart</label>
                </div>
            </div>
            <!-- Frist für Mängelansprüche -->
                <!-- SICHTBAR wenn Mängelansprüchebürgschaft, Vertragserfüllungsbürgschaft oder Ausführungsbürgschaft -->
            <div [className]="['MA', 'VE', 'AF'].includes(model.buergschaftsArt.value) ? 'show' : 'hide'">
                <div class="row trenner"></div>
                <div class="row">
                    <div class="cell grid-25 alignr">
                        <label class="field-label">Die Frist für Mängelansprüche (Gewährleistungsfrist) beträgt:&nbsp;*</label>
                    </div>
                    <div class="cell grid-25">
                        <input type="radio"
                               name="f_maengelansprueche_frist"
                               id="f_maengelansprueche_frist_5j"
                               value="5"
                               [(ngModel)]="model.gewaehrleistungsfrist.value"
                               [class.error]="model.gewaehrleistungsfrist.valid === false"
                               (change)="validateField(model.gewaehrleistungsfrist)">
                        <label for="f_maengelansprueche_frist_5j">5 Jahre</label>
                    </div>
                    <div class="cell grid-25">
                        <input type="radio"
                               name="f_maengelansprueche_frist"
                               id="f_maengelansprueche_frist_4j"
                               value="4"
                               [(ngModel)]="model.gewaehrleistungsfrist.value"
                               [class.error]="model.gewaehrleistungsfrist.valid === false"
                               (change)="validateField(model.gewaehrleistungsfrist)">
                        <label for="f_maengelansprueche_frist_4j">4 Jahre</label>
                    </div>
                    <div class="cell grid-25"></div>
                </div>
                <div class="row" style="margin-top: 1rem; margin-bottom: 0">
                    <div class="cell grid-25"></div>
                    <div class="cell grid-25">
                        <input type="radio"
                               name="f_maengelansprueche_frist"
                               id="f_maengelansprueche_frist_betraegt"
                               value="beträgt"
                               [(ngModel)]="model.gewaehrleistungsfrist.value"
                               [class.error]="model.gewaehrleistungsfrist.valid === false"
                               (change)="validateField(model.gewaehrleistungsfrist)">
                        <label for="f_maengelansprueche_frist_betraegt">individuelle Frist</label>
                    </div>
                    <div class="cell grid-50">
                        <div [className]="model.gewaehrleistungsfrist.value === 'beträgt' ? 'show' : 'hide'">
                            <input type="text"
                                   maxlength="2"
                                   name="f_maengelansprueche_frist_jahre"
                                   id="f_maengelansprueche_frist_jahre"
                                   value=""
                                   style="width: 3rem; margin-right: 1rem;"
                                   [(ngModel)]="model.gewaehrleistungsfristJahre.value"
                                   [class.error]="model.gewaehrleistungsfristJahre.valid === false"
                                   (blur)="validateField(model.gewaehrleistungsfristJahre)">
                            @if (model.gewaehrleistungsfristJahre.valid === false) {
                                <div
                                    class="errorMessage"
                                    [innerHTML]="model.gewaehrleistungsfristJahre.errorMsg"></div>
                            }
                            <label for="f_maengelansprueche_frist_jahre">Jahr(e)</label>
                            <input type="text"
                                   maxlength="2"
                                   name="f_maengelansprueche_frist_monate"
                                   id="f_maengelansprueche_frist_monate"
                                   value=""
                                   style="width: 3rem; margin-left: 1.5rem; margin-right: 1rem;"
                                   [(ngModel)]="model.gewaehrleistungsfristMonate.value"
                                   [class.error]="model.gewaehrleistungsfristMonate.valid === false"
                                   (blur)="validateField(model.gewaehrleistungsfristMonate)">
                            @if (model.gewaehrleistungsfristMonate.valid === false) {
                                <div
                                    class="errorMessage"
                                    [innerHTML]="model.gewaehrleistungsfristMonate.errorMsg"></div>
                            }
                            <label for="f_maengelansprueche_frist_monate">Monat(e)</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row trenner"></div>
            <!-- Besondere Hinweise zur Bürgschaft -->
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Besondere Hinweise zu Bürgschaft:</label>
                </div>
                <div class="cell grid-50">
                    <input type="checkbox"
                           id="f_hat_besondere_hinweise"
                           name="f_hat_besondere_hinweise"
                           value="checkboxHatBesondereHinweise"
                           [(ngModel)]="model.checkboxHatBesondereHinweise.value">
                    <label for="f_hat_besondere_hinweise">Ich habe besondere Hinweise zur Bürgschaft</label>
                </div>
                <div class="cell grid-25"></div>
            </div>
            <div [ngClass]="['row', model.checkboxHatBesondereHinweise.value ? 'show' : 'hide']">
                <div class="cell grid-25"></div>
                <div class="cell grid-50">
                    <elem-textarea inputElemId="f_besondere_hinweise"
                                   inputElemName="f_besondere_hinweise"
                                   placeholder="Bitte geben Sie die besonderen Hinweise hier ein."
                                   maxLength="70"
                                   [fieldModel]="model.besondereHinweise"
                                   [allowLineBreaks]="false"></elem-textarea>
                </div>
                <div class="cell grid-25"></div>
            </div>
        }

        <div class="row hl">
            Auftragsbeschreibung / Bauleistung
        </div>

        <!-- Gewerk / Art der Arbeit -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <!--suppress XmlInvalidId -->
                <label class="field-label" for="f_gewerk">Gewerk / Art der Arbeit:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <elem-textarea inputElemId="f_gewerk"
                               inputElemName="f_gewerk"
                               maxLength="240"
                               placeholder="Bitte beschreiben Sie hier Ihre Bauleistung(en) oder Lieferungen."
                               [required]="true"
                               [allowLineBreaks]="false"
                               [fieldModel]="model.auftragsortGewerk"
                               (blur)="validateField(model.auftragsortGewerk)"></elem-textarea>
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Ort der Arbeit -->
        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label">Ort der Arbeit:&nbsp;*</label>
            </div>
            <div class="cell grid-25">
                <input type="radio"
                       id="f_arbeitsort_adresse"
                       name="f_arbeitsort"
                       value="AV"
                       [(ngModel)]="model.auftragsortVerfuegbar.value"
                       [class.error]="model.auftragsortVerfuegbar.valid === false"
                       (mouseup)="validateField(model.auftragsortVerfuegbar)">
                <label for="f_arbeitsort_adresse">Adresse verfügbar</label>
            </div>
            <div class="cell grid-50">
                <input type="radio"
                       id="f_arbeitsort_keine_adresse"
                       name="f_arbeitsort"
                       value="KA"
                       [(ngModel)]="model.auftragsortVerfuegbar.value"
                       [class.error]="model.auftragsortVerfuegbar.valid === false"
                       (mouseup)="validateField(model.auftragsortVerfuegbar)">
                <label for="f_arbeitsort_keine_adresse">Keine Adresse verfügbar
                    <elem-tooltip text="Erläuterung: Falls keine Anschrift des Bauvorhabens existiert, wählen Sie bitte diese Option und geben eine möglichst genaue Beschreibung des Ortes (Autobahnabschnitt XY, Erschließungsgebiet XY, etc.) an."></elem-tooltip>
                </label>
            </div>
        </div>

        <!-- Arbeitsort Straße, Hausnummer / Postfach -->
        <!-- SICHTBAR wenn "Adresse verfügbar" gewählt -->
        <div [ngClass]="['row', model.auftragsortVerfuegbar.value === 'AV' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_bv_strasse_hausnummer_postfach">Straße, Hausnr. / Postfach:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <input type="text"
                       id="f_bv_strasse_hausnummer_postfach"
                       name="f_bv_strasse_hausnummer_postfach"
                       maxlength="60"
                       value=""
                       placeholder="Straße, Hausnummer"
                       required
                       [(ngModel)]="model.auftragsortStrasseNr.value"
                       [class.error]="model.auftragsortStrasseNr.valid === false"
                       (blur)="validateField(model.auftragsortStrasseNr)">
                @if (model.auftragsortStrasseNr.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.auftragsortStrasseNr.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Arbeitsort PLZ und Ort -->
        <!-- SICHTBAR wenn "Adresse verfügbar" gewählt -->
        <div [ngClass]="['row', model.auftragsortVerfuegbar.value === 'AV' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <label class="field-label">PLZ und Ort:&nbsp;*</label>
            </div>
            <div class="cell grid-20">
                <input type="text"
                       id="f_bv_plz"
                       name="f_bv_plz"
                       maxlength="5"
                       value=""
                       placeholder="PLZ"
                       aria-label="PLZ"
                       required
                       [(ngModel)]="model.auftragsortPlz.value"
                       [class.error]="model.auftragsortPlz.valid === false"
                       (blur)="validateField(model.auftragsortPlz)">
                @if (model.auftragsortPlz.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.auftragsortPlz.errorMsg"></div>
                }
            </div>
            <div class="cell grid-30">
                <input type="text"
                       name="f_bv_ort"
                       maxlength="79"
                       value=""
                       placeholder="Ort"
                       aria-label="Ort"
                       required
                       [(ngModel)]="model.auftragsortOrt.value"
                       [class.error]="model.auftragsortOrt.valid === false"
                       (blur)="validateField(model.auftragsortOrt)">
                @if (model.auftragsortOrt.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.auftragsortOrt.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <!-- Arbeitsort Beschreibung des Ortes -->
        <!-- SICHTBAR wenn "Keine Adresse verfügbar" gewählt -->
        <div [ngClass]="['row', model.auftragsortVerfuegbar.value === 'KA' ? 'show' : 'hide']">
            <div class="cell grid-25 alignr">
                <!--suppress XmlInvalidId -->
                <label class="field-label" for="f_beschreibung_arbeitsort">Beschreibung des Ortes:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <elem-textarea inputElemId="f_beschreibung_arbeitsort"
                               inputElemName="f_beschreibung_arbeitsort"
                               maxLength="60"
                               placeholder="Bitte geben Sie hier eine möglichst genaue Beschreibung des Ortes."
                               [required]="true"
                               [allowLineBreaks]="false"
                               [fieldModel]="model.auftragsortBeschreibung"
                               (blur)="validateField(model.auftragsortBeschreibung)"></elem-textarea>
            </div>
            <div class="cell grid-25"></div>
        </div>

        @if (model.versandartAuswahlAvailable) {
            <div class="row hl">
                Versandart
            </div>
            <div class="row">
                <div class="cell grid-25 alignr">
                    <label class="field-label">Bürgschaftsformat:&nbsp;*</label>
                </div>
                <div class="cell grid-25">
                    <input type="radio"
                           id="f_buergschaftformat_papier"
                           name="f_buergschaftformat"
                           value="PAPIER"
                           [(ngModel)]="model.buergschaftsformat.value"
                           [class.error]="model.buergschaftsformat.valid === false"
                           (mouseup)="validateField(model.buergschaftsformat)">
                    <label for="f_buergschaftformat_papier">Papierbürgschaft</label>
                </div>
                <div class="cell grid-50">
                    <input type="radio"
                           id="f_buergschaftformat_pdf"
                           name="f_buergschaftformat"
                           value="PDF"
                           [(ngModel)]="model.buergschaftsformat.value"
                           [class.error]="model.buergschaftsformat.valid === false"
                           (mouseup)="validateField(model.buergschaftsformat)">
                    <label for="f_buergschaftformat_pdf">PDF-Bürgschaft</label>
                </div>
            </div>
            <div class="row">
                <!-- Info-Box -->
                @if (model.buergschaftsformat.value === 'PDF') {
                    <div class="info-row top-margin">
                        <div class="info-row__icon">
                            <i class="icon ico-info pos-top-icon"></i>
                        </div>
                        <div class="info-row__text">Erläuterung: Diese Bürgschaft wird digital im PDF-Format zur Verfügung gestellt.
                            Sie erhalten von uns eine E-Mail mit dem Hinweis, dass Ihnen die PDF-Bürgschaft im Kreditportal zum Download und
                            zur Weiterleitung bereitgestellt wurde.</div>
                    </div>
                }
            </div>
        }

        <div class="row trenner"></div>

        <div class="row">
            <div class="cell grid-25">
                <elem-button buttonRole="TERTIARY" class="expand" (click)="setCreationState(STATE_2_AUFTRAGGEBER, false)">
                    Zurück
                </elem-button>
            </div>
            <div class="cell grid-50">
            </div>
            <div class="cell grid-25">
                <elem-button class="expand" (click)="setCreationState(STATE_4_ABSCHLUSS, true)">
                    Weiter
                </elem-button>
            </div>
        </div>

    </div>
</div>

<!--  #####################################################  -->
<!--  4. Abschlusserklärung                                  -->
<!--  #####################################################  -->
<div [ngClass]="['gridContainer', 'formStep4', createState === STATE_4_ABSCHLUSS ? 'show' : 'hide']">

    <h2>
        Ihre Angaben in der Übersicht
    </h2>

    <div class="gridContainer dataGrid fitGrid">

        <div class="row">
            <div class="cell grid-25">
                <span class="angaben-category">1. Angaben zum Antragsteller</span>
            </div>

            <div class="cell grid-75 angaben">
                <bgsch-create-abschl-1 [model]="model" [context]="this"></bgsch-create-abschl-1>
            </div>
        </div>

        <div class="row trenner"></div>

        <div class="row">
            <div class="cell grid-25">
                <span class="angaben-category">2. Angaben zum Auftraggeber</span>
            </div>

            <div class="cell grid-75 angaben">
                <bgsch-create-abschl-2 [model]="model" [context]="this"></bgsch-create-abschl-2>
            </div>
        </div>

        <div class="row trenner"></div>

        <div class="row">
            <div class="cell grid-25">
                <span class="angaben-category">3. Angaben zur Bürgschaft</span>
            </div>

            <div class="cell grid-75 angaben">
                <bgsch-create-abschl-3 [model]="model" [context]="this"></bgsch-create-abschl-3>
            </div>
        </div>

        <div class="row trenner"></div>

        <h2>
            Erklärung
        </h2>

        <div class="row">
            <div class="cell grid-100">
                Ich bestätige, dass ich zur Antragstellung handlungsbefugt und berechtigt bin.
                Die vorstehenden Fragen wurden vollständig und nach bestem Wissen und Gewissen beantwortet. Die Angaben entsprechen dem derzeitigen Stand.
                Außerdem bin ich damit einverstanden, dass digitale Bürgschaften von der VHV dem Auftraggeber auf der Serviceplattform der
                Trustlog GmbH, Heidenkampsweg 100, 20097 Hamburg, zur Verfügung gestellt werden, sofern sich der
                Auftraggeber dort für die Verwendung von digitalen Bürgschaften registriert hat.
                Die aktuellen <a [attr.href]="urlBuergscheinAntragBedingungenPdf" target="_blank">Allgemeinen Versicherungsbedingungen
                für die Kautionsversicherung</a> und die aktuellen Nutzungsbedingungen für das VHV Kreditportal erkenne(n) ich/wir an.
            </div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label">Zustimmung:&nbsp;*</label>
            </div>
            <div class="cell grid-75">
                <input type="checkbox"
                       id="f_zustimmung_erklaerung"
                       name="f_zustimmung_erklaerung"
                       value="zugestimmt"
                       [(ngModel)]="model.checkboxErklaerungZustimmung.value"
                       [class.error]="model.checkboxErklaerungZustimmung.valid === false">
                <label for="f_zustimmung_erklaerung">Ich stimme der obigen Erklärung zu</label>
                @if (model.checkboxErklaerungZustimmung.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.checkboxErklaerungZustimmung.errorMsg"></div>
                }
            </div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr field-label">
                Datum:&nbsp;*
            </div>
            <div class="cell grid-25">
                {{ model.erklaerungsDatum.value }}
            </div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_erklaerung_ort">Ort:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <input type="text"
                       name="f_erklaerung_ort"
                       id="f_erklaerung_ort"
                       maxlength="79"
                       value=""
                       placeholder="Ort"
                       required
                       [(ngModel)]="model.erklaerungsOrt.value"
                       [class.error]="model.erklaerungsOrt.valid === false"
                       (blur)="validateField(model.erklaerungsOrt)">
                @if (model.erklaerungsOrt.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.erklaerungsOrt.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div class="row">
            <div class="cell grid-25 alignr">
                <label class="field-label" for="f_erklaerung_name">Name:&nbsp;*</label>
            </div>
            <div class="cell grid-50">
                <input type="text"
                       maxlength="79"
                       id="f_erklaerung_name"
                       name="f_erklaerung_name"
                       value=""
                       placeholder="Vor- und Zuname"
                       required
                       [(ngModel)]="model.erklaerungsName.value"
                       [class.error]="model.erklaerungsName.valid === false"
                       (blur)="validateField(model.erklaerungsName)">
                @if (model.erklaerungsName.valid === false) {
                    <div
                        class="errorMessage"
                        [innerHTML]="model.erklaerungsName.errorMsg"></div>
                }
            </div>
            <div class="cell grid-25"></div>
        </div>

        <div class="row trenner"></div>

        <div class="row">
            <div class="cell grid-25">
                <elem-button buttonRole="TERTIARY" class="expand" (click)="setCreationState(STATE_3_BUERGSCHAFT, false)">
                    Zurück
                </elem-button>
            </div>
            <div class="cell grid-50">
            </div>
            <div class="cell grid-25">
                <elem-button class="expand" (click)="sendData()" [disabled]="buergschaftBeantragenBtnDisabled">
                    Bürgschaft verbindlich beantragen
                </elem-button>
            </div>
        </div>

    </div>
</div>

<!--  #####################################################  -->
<!--  5. Dankesseite                                         -->
<!--  #####################################################  -->
<div [ngClass]="['gridContainer', 'formStep4', createState === STATE_5_DANKESSEITE ? 'show' : 'hide']">
    <h2>
        Vielen Dank!
    </h2>

    <div class="gridContainer fitGrid">
        <div class="row" style="margin-bottom: 30px;">
            <div class="cell grid-100">
                Wir haben Ihren Bürgschaftsauftrag erhalten. Digitale Bürgschaften erhält Ihr Auftraggeber direkt.
                Sie erhalten von uns eine entsprechende Benachrichtigung im Posteingang. Wenn sich Ihr Auftraggeber
                für den Erhalt von digitalen Bürgschaften noch nicht registriert hat, senden wir Ihnen die Bürgschaft
                wie gewohnt in Papierform zu.
            </div>
        </div>

        <print-buergschein-antrag [model]="model"></print-buergschein-antrag>

        <div class="row trenner"></div>

        <div class="row">
            <div class="cell grid-75">
            </div>
            <div class="cell grid-25">
                <elem-button class="expand" (click)="starteWeiterenAntrag()">
                    Nächster Antrag
                </elem-button>
                <br/><br/><br/>
            </div>
        </div>
    </div>

</div>

<erweiterte-auftraggeber-suche appName="kreditportal" (searchResultSelected)="onAuftraggeberSucheResultSelected($event)"></erweiterte-auftraggeber-suche>
